/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

/*var elementMenu = document.getElementById("woocommerce-categories-id");

document.querySelectorAll('.category-toggle').forEach(item => {
  item.addEventListener('click', event => {


    // item.classList.add("mystyle");
    item.classList.toggle("is-active-button");

    elementMenu.classList.toggle("mystyle");

  });
});
 */

/**
 * Accordion Component
 *
 * Sets attribute "aria-expanded" to true/false, which is used
 * in _component-accordion.scss to determine which accordion to display
 */

 const x_accordion_init = (accordion, i) => {
  let tab = accordion;
  let panel = accordion.parentNode.querySelector('.woocommerce-categories');

  tab.setAttribute('aria-controls', 'accordion-' + i);
  panel.setAttribute('id', 'accordion-' + i);
  panel.setAttribute('aria-labelledby', 'accordion-' + i);
};

const x_accordion_focus = (e) => {
  let tab = e.currentTarget;

  if (tab.getAttribute('aria-selected') === 'true') {
    tab.setAttribute('aria-selected', 'false');
  } else {
    tab.setAttribute('aria-selected', 'true');
  }
};

const x_accordion_toggle = (e) => {
  e.stopPropagation();

  let tab = e.currentTarget;
  let panel = e.currentTarget.parentNode.querySelector('.woocommerce-categories');

  if (tab.getAttribute('aria-expanded') === 'true') {
    tab.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
  } else {
    tab.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
  }
};

const x_accordion_find_and_init = () => {
  let accordion = document.querySelectorAll('.category-toggle');
  for (let i = 0; i < accordion.length; i++) {
    x_accordion_init(accordion[i], i);

    accordion[i].addEventListener('click', x_accordion_toggle);
    accordion[i].addEventListener('focus', x_accordion_focus);
    accordion[i].addEventListener('blur', x_accordion_focus);
  }
}

x_accordion_find_and_init();


(function($) {
  $(document).on('facetwp-loaded', function() {
      if (FWP.loaded) {
          $('html, body').animate({
              scrollTop: $('.facetwp-template').offset().top - 50
          }, 500);
      }
  });
})(jQuery);